import { useMutation } from '@tanstack/react-query';
import { logout } from '../api/AUTH/auth';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';

export const useLogout = () => {
  const { logOut } = useAuth();

  return useMutation({
    mutationFn: logout,
    onSuccess: () => {
      logOut(); 
    },
    onError: (error) => {
      toast.error(error.message || 'Erreur lors de la déconnexion');
    },
  });
};
